export const notificationsReducer = (state = {loading: false, resultnotification: null, notifications: [], notification: null } , action) => {
    switch (action.type) {
        case 'NOTIFICATION_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                notifications: action.payload.notifications
            }
        case 'NOTIFICATION_EDIT_SUCCESS':
            const payloadIds = Array.isArray(action.payload) ? action.payload : [action.payload];
            return {
                ...state,
                loading: false,
                notifications: state.notifications.filter(notification => !payloadIds.includes(notification._id)),
            }
        // case 'NOTIFICATION_ADD_SOCKET_SUCCESS':
        //     const notificationIsAlready = state.notifications.find(notification => notification._id === action.payload._id)
        //     if(!notificationIsAlready){
        //         return {...state, notifications: [...state.notifications, action.payload]}
        //     } else {
        //         return state
        //     }
        default:
            return state
    }
}